<template>
  <v-flex md3 >  
    <v-card>
      <v-card-media
        :src="'https://picsum.photos/1000/700?image='+inc"
        height="100px"
      >
        <v-spacer></v-spacer>
        <v-tooltip bottom lazy>
          <v-menu offset-y slot="activator">
            <v-btn flat icon slot="activator" color="white">
              <v-icon>more_vert</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile @click="deleteDialog = true">
                <v-list-tile-title>Unenroll</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <span>More actions</span>
        </v-tooltip>
      </v-card-media>
      <v-card-title primary-title>
        <div>
          <router-link style="cursor: pointer;" class="underline" :to="'/student/classroom/' + classroom.classroom_id">
            <div class="headline">{{classroom.classroom_name}}</div>
          </router-link>
          <div class="grey--text">Subject: {{ classroom.subject }}</div>
          <div class="grey--text">Section: {{ classroom.section }}</div>
          <div class="grey--text">Class Code: {{ classroom.classroom_id }}</div>
        </div>
      </v-card-title>
    </v-card>

    <v-layout row justify-center>
      <v-dialog v-model="deleteDialog" persistent max-width="300">
        <v-card>
          <v-card-text>
            <p>Are you sure you want to leave this class?</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="gray" flat @click="deleteDialog = false" :disabled="loading">Close</v-btn>
            <v-btn 
              dark
              color="red" 
              :loading="loading"
              :disabled="loading"
              @click="unenroll"
            >
              Remove
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>


  </v-flex>
</template>

<script>
import axios from 'axios'
export default {
  props: ['classroom', 'inc'],
  data(){
    return {
      deleteDialog: false,
      loading: false
    }
  },
  methods: {
    async unenroll(){
      try{
        this.loading = true
        let res = await axios.post(`/api/class/leave`, {
          class_code: `${this.classroom.classroom_id}`
        }, {
          headers: { 
            'Authorization': `Bearer ${this.$store.getters.GET_TOKEN}` 
          }
        })
        this.loading = false
        this.deleteDialog = false
        this.$store.dispatch('student/FETCH_CLASSES')
      }catch(e){
        this.loading = false
        console.log(e)

      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Student/ClassroomCard.vue